import { useQuery } from "@tanstack/react-query";
import { LiveContestInfo } from "./queryTypes";

export const useGetLiveContests = (slateId: string, disable: boolean) => {
  const params = {
    slateId
  }
  return useQuery<LiveContestInfo[], Error>({
    queryKey: [`slateInfo-${slateId}`],
    queryFn: () => {
      const data: Promise<LiveContestInfo[]> = fetch(`${process.env.REACT_APP_API_URL}/api/contests/getLiveOwnershipContests?` + new URLSearchParams(params)).then(res => res.json());

      return data;
    },
    refetchOnWindowFocus: false,
    enabled: !disable,
    cacheTime: 0 // disables caching
  })
};